export default "__VITE_ASSET__a34c9d4e__"